import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject } from 'rxjs';
import { ErrorService } from './error.service';
import { AuthConfigService } from './auth/auth-config.service';

@Injectable({
  providedIn: 'root'
})
export class CarrierService {

  public carriers$ = new BehaviorSubject<string[]>([]);

  constructor(private httpClient: HttpClient,
    private errorService: ErrorService,
    private authConfig: AuthConfigService) {
  }

  public getCarrierCodes() {
    this.httpClient
      .get<any>(this.authConfig.getConfig().dppApiUrl + 'dppservice/getCarrierCodes')
      .subscribe(
        res => this.carriers$.next(res.carrierCodeList),
        err => this.errorService.setError(err)
      );
  }
}
